
<div class="container mainbox">
    <form [formGroup]="mainDataForm" *ngIf="loadCashback$ | async as data; else loading">
        <h1 class="form-group title-position" translate>cashback.title</h1>

        <!-- ****************************************************** 
        ************** Core Cashback Data *************
        ****************************************************** -->
        <div id="mainContent" role="tablist" aria-multiselectable="true">
            <div class="card">
                <div class="card-header" id="mainSection">
                        <h5 class="mb-0">
                            <button class="btn btn-link" data-toggle="collapse" data-target="#collapseMainSection"
                                aria-expanded="true" aria-controls="collapseMainSection" translate>
                                cashback.mainSection
                            </button>
                        </h5>
                </div>
                <div id="collapseMainSection" class="collapse show" aria-labelledby="mainSection" data-parent="#mainContent">
                    <div class="card-body">
                        <div class="container-fluid row">
                            <div class="col-lg-4 col-md-6 ">
                                <div><label style="margin-top: 12px;" translate>cashback.serviceType</label></div>
                                <select class="custom-select input-custom-size" style="width: 200pt" [compareWith]="compareById" formControlName="serviceType" (change)="onServiceTypeChange($event)"
                                        [ngClass]="{ 'is-invalid': showValidations && mainDataForm.get('serviceType')?.errors }" >
                                    <option value="null" disabled translate>placeholder.select</option>
                                    <option *ngFor="let serviceType of serviceTypes" [ngValue]="serviceType" > {{serviceType.description}}
                                </select>
                                <div class="invalid-feedback" *ngIf="mainDataForm.get('serviceType')?.errors?.required && showValidations" translate>errors.required</div>  
                            </div>
                            
                            <div class="col-lg-4 col-md-6 ">
                                <div><label style="margin-top: 12px;" translate>cashback.service</label></div>
                                <select class="custom-select input-custom-size" style="width: 200pt" [compareWith]="compareById" formControlName="service"
                                        [ngClass]="{ 'is-invalid': showValidations && mainDataForm.get('service')?.errors }" >
                                    <option value="null" disabled translate>placeholder.select</option>
                                    <option *ngFor="let service of filteredServices" [ngValue]="service" > {{service.name}}
                                </select>
                                <div class="invalid-feedback" *ngIf="mainDataForm.get('service')?.errors?.required && showValidations" translate>errors.required</div>  
                            </div>
                            
                            <div class="col-lg-4 col-md-6 ">
                                <label style="margin-top: 12px;" translate>cashback.moneyValueOfPoint</label>
                                <div class="input-group" style="width: 200pt">
                                    <input type="number" class="form-control" formControlName="moneyValueOfPoint"
                                        placeholder="{{'placeholder.enter' | translate}}" [ngClass]="{ 'is-invalid': showValidations && mainDataForm.get('moneyValueOfPoint')?.errors }">
                                    <div class="input-group-append">
                                        <span class="input-group-text">лв.</span>
                                    </div>
                                </div>
                                <div class="invalid-feedback" *ngIf="mainDataForm.get('moneyValueOfPoint')?.errors?.required && showValidations" translate>errors.required</div>  
                                <div class="invalid-feedback" *ngIf="mainDataForm.get('moneyValueOfPoint')?.errors?.min && showValidations" translate>errors.onlyPositiveNumbers</div>
                            </div>
                            
                            <div class="col-lg-4 col-md-6 ">
                                <div style="width: 200pt">
                                    <label style="margin-top: 12px;" translate>cashback.priceAttributeKind</label>
                                    <select class="custom-select input-custom-size" aria-describedby="priceAttributeKind" formControlName="priceAttributeKind" (change) = "changePriceAttrKind($event)"
                                    [ngClass]="{ 'is-invalid': showValidations && mainDataForm.get('priceAttributeKind')?.errors }">
                                        <option value="null" disabled translate>placeholder.select</option>
                                        <option value="P" translate> cashback.discountPercent </option>
                                        <option value="V" translate> cashback.discountInValue </option>
                                    </select>
                                    <div class="invalid-feedback" *ngIf="mainDataForm.get('priceAttributeKind')?.errors?.required && showValidations" translate>errors.required</div>  
                                </div>
                            </div>
                            
                            <div class="col-lg-4 col-md-6 ">
                                <label style="margin-top: 12px;" translate>cashback.amount</label>
                                <input style="width: 200pt" type="number" class="form-control" aria-describedby="priceAttributeAmountDds" formControlName="priceAttributeAmountDds"
                                    placeholder="{{'placeholder.enter' | translate}}" [ngClass]="{ 'is-invalid': showValidations && mainDataForm.get('priceAttributeAmountDds')?.errors }">
                                <div class="invalid-feedback" *ngIf="mainDataForm.get('priceAttributeAmountDds')?.errors?.required && showValidations" translate>errors.required</div>
                                <div class="invalid-feedback" *ngIf="mainDataForm.get('priceAttributeAmountDds')?.errors?.min && showValidations" translate>errors.onlyPositiveNumbers</div>
                                <div class="invalid-feedback" *ngIf="mainDataForm.get('priceAttributeAmountDds')?.errors?.max && showValidations" translate>errors.tooLong</div>
                            </div>
                            
                            <div class="col-lg-4 col-md-6 ">
                                <div><label style="margin-top: 12px;" translate>cashback.status</label></div>
                                <select class="custom-select input-custom-size" style="width: 200pt" [compareWith]="compareById" formControlName="status"
                                        [ngClass]="{ 'is-invalid': showValidations && mainDataForm.get('status')?.errors }" >
                                    <option value="null" disabled translate>placeholder.select</option>
                                    <option *ngFor="let status of statuses" [ngValue]="status" > {{status.name}}
                                </select>
                                <div class="invalid-feedback" *ngIf="mainDataForm.get('status')?.errors?.required && showValidations" translate>errors.required</div>  
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </form>

    <!-- ****************************************************** 
    ************** Save And Deactivate Button *************
    ****************************************************** -->
    <div class="text-right" *ngIf="dataLoaded">
        <button class="btn btn-primary w-20" [disabled]="disableActionBtn" style="margin-top: 10px;" (click)="save(false)"  *ngIf="cashback?.status?.code != ACTIVE_STATUS_CODE" translate>button.save</button>
        <button class="btn btn-primary w-20" [disabled]="disableActionBtn" style="margin-top: 10px;"  (click)="deactivate()" *ngIf="(cashback?.status?.code == ACTIVE_STATUS_CODE && cashbackId != null)" translate>Деактивирай</button>
    </div>

    <ng-container *ngIf="!disableActionBtn; else dataLoadingTemplate"></ng-container>

    <ng-template #loading>
        <div *ngIf="errorMessage$ | async as errorMessage; else spinner">
            <div class="alert alert-danger">
                {{errorMessage}}
            </div>
            <div class="d-flex justify-content-center">
                <i class="fa fa-refresh" (click)="reload()"></i>
            </div>
        </div>
        <ng-template #spinner>
            <div class="d-flex justify-content-center">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </ng-template>
    </ng-template>
</div>

<ng-template #dataLoadingTemplate>
    <div *ngIf="errorMessage$ | async as errorMessage; else dataSpinner" >
        <div class="alert alert-danger">
            {{errorMessage}}
        </div>
        <div class="d-flex justify-content-center">
            <i class="fa fa-refresh" (click)="reload()"></i>
        </div>
    </div>
    <ng-template #dataSpinner>
        <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </ng-template>
</ng-template>